var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.9999C20.5575 10.5586 19.9582 10.3108 19.3333 10.3108C18.7084 10.3108 18.109 10.5586 17.6666 10.9999L17.4733 11.1932L20.8066 14.5266L21 14.3333C21.4413 13.8908 21.6891 13.2915 21.6891 12.6666C21.6891 12.0417 21.4413 11.4423 21 10.9999ZM11.7 16.9999C11.4601 17.241 11.2857 17.5393 11.1933 17.8666L10.5266 20.2999C10.4864 20.4664 10.4897 20.6405 10.5361 20.8054C10.5825 20.9703 10.6705 21.1205 10.7916 21.2416C10.9127 21.3627 11.0629 21.4507 11.2278 21.4971C11.3927 21.5435 11.5668 21.5468 11.7333 21.5066L14.1666 20.8066C14.4939 20.7141 14.7922 20.5397 15.0333 20.2999L19.86 15.4732L16.5266 12.1399L11.7 16.9999Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/edit-circle.90d46d46a28dc6574949a504a8257cf2.svg";
export { ForwardRef as ReactComponent };